import type { Device } from '../api/types';

/** A virtual network as the console can see it: there is no networks API, so it is derived from /devices. */
export interface NetworkSummary {
  id: string;
  /** The /24 its members' overlay addresses fall in, e.g. "10.88.1.0/24". */
  cidr: string;
  devices: number;
}

/** "10.88.1.20" -> "10.88.1.0/24". */
export function slash24(ip: string): string {
  const [a, b, c] = ip.split('.');
  return `${a}.${b}.${c}.0/24`;
}

const thirdOctet = (cidr: string) => Number(cidr.split('.')[2]);

/**
 * One entry per `network` among the devices, sorted by CIDR. Legacy devices (network null,
 * the old flat 10.88.0.x range) belong to no network and are left out.
 */
export function networksFromDevices(devices: Device[]): NetworkSummary[] {
  const byId = new Map<string, NetworkSummary>();
  for (const d of devices) {
    if (!d.network) continue;
    const n = byId.get(d.network);
    if (n) n.devices += 1;
    else byId.set(d.network, { id: d.network, cidr: slash24(d.overlayIp), devices: 1 });
  }
  return [...byId.values()].sort((x, y) => thirdOctet(x.cidr) - thirdOctet(y.cidr) || x.id.localeCompare(y.id));
}
